<template>
  <div>

    <table v-if="isRatingVisible" class="rating-table table text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th scope="col">№</th>
          <th scope="col">Игрок</th>
          <th scope="col">Участие</th>
          <th scope="col">Присоединение</th>
          <th scope="col">Выход</th>
          <th scope="col">Очки</th>
          <th scope="col">Место</th>
          <th scope="col">Участник ража</th>
          <th scope="col">Участник заезда</th>
        </tr>
      </thead>
      <tr
        v-for="(record, index) in rating"
        :key="record.playerId"
      >
        <td class="text-right">
          {{index + 1 | getFormattedNumber}}
        </td>
        <td>
          <player-link :playerId="record.playerId" label="игрок"/>
        </td>
        <td :class="getParticipantStateClass(record.state)">
          {{ record.state | getParticipantStateName }}
        </td>
        <td>{{ record.joinTime  | getMomentStr }}</td>
        <td>{{ record.leaveTime | getMomentStr }}</td>
        <td class="text-right">
          {{record.score | getFormattedNumber}}
        </td>
        <td class="text-right">
          {{record.place | getFormattedNumber}}
        </td>
        <td>
          <rush-player-link :rushPlayerId="createRushPlayerId(record.playerId)">
            участник ража
          </rush-player-link>
        </td>
        <td>
          <rush-race-player-link :rushRaceId="rushRaceId" :playerId="record.playerId">
            участник заезда
          </rush-race-player-link>
        </td>
      </tr>
    </table>

    <loading-indicator v-if="isLoading"/>

  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

import { getParticipantStateName  } from '../model/rush_participant.js';
import { getParticipantStateClass } from '../model/rush_participant.js';

import LoadingIndicator from './LoadingIndicator.vue';
import PlayerLink from './PlayerLink.vue';
import RushPlayerLink from './RushPlayerLink.vue';
import RushRacePlayerLink from './RushRacePlayerLink.vue';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'RushRaceRating',

  components: {
    LoadingIndicator,
    PlayerLink,
    RushPlayerLink,
    RushRacePlayerLink,
  },

  props: {
    rushRaceId: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {
      loadingStatus: LOADING_STATUS__INIT,

      /** @type {?Array} */
      rating: null,
    };
  },

  computed: {
    rushId() {
      return this.rushRaceId.rushId;
    },

    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    isRatingVisible() {
      return this.isLoadedNormal && (this.rating !== null);
    },
  },

  created() {
    this.loadRace();
  },

  methods: {
    loadRace() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const rushId = this.rushRaceId.rushId;
      const raceId = this.rushRaceId.raceId;
      const url = `/rush/${rushId}/race/${raceId}/rating`;

      HTTP.get(url)
      .then(response => {
        this.rating = response.data.data;
        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },

    /** @param {number} playerId */
    createRushPlayerId(playerId) {
      return {
        rushId:   this.rushId,
        playerId: playerId,
      };
    },

    getParticipantStateClass,
  },

  filters: {
    getParticipantStateName,
  },
};
</script>

<style scoped>
.rating-table {
  max-width: 1px;
}
</style>
